import IconWithMessage from './icon-with-message';
import './icon-with-message.scss';

export default IconWithMessage;
